/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 * 
 * Produktgruppen anzeigen
 * 
 */
import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { IconEdit } from "../../partials/Icons";
import { IconDelete } from "../../partials/Icons";
import { ImageLoader } from "../../partials/ImageLoader";

import GroupPortrait from "./GroupPortrait";
import GroupLandscape from "./GroupLandscape";

import * as portfolioActions from "../../../store/actions/portfolioActions";
import * as appActions from "../../../store/actions/appActions";
import * as fileActions from "../../../store/actions/fileActions";
import * as utils from "../../../basics/utils";

/* ag-grid-react */
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';

class GroupController extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;

        this.state = { reorderMode: true };

        this.agGridRightApi = null;
        this.agGridRightColumnApi = null;
        this.agGridRightWidth = 0;
        this.agGridRightVisibleItems = 3;

        this.agGridRowHeight = 200;
        this.agGridHeaderHeight = 0;

        this.timestamp = 0;
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { windowWidth, inputHeight, headerHeight, unitHeight, path, orientation, groupPos, appModus, toolbarType } = this.props.app;
        const { currentPortfolio } = this.props.portfolio;
        const { file } = this.props;

        const itemWidth = (orientation === 'landscape') ? windowWidth / 6.5 : windowWidth / 4.7;
        const fontFactor = (orientation === 'landscape') ? windowWidth / 100 * 1.3 : windowWidth / 100 * 2.5;

        const dialog = utils.getDialogByPath(path);

        const node = utils.getTreePortfolio(dialog.portfolio, true);
        if (node === null) return null;

        this.agGridRowHeight = itemWidth;
        this.agGridRightWidth = itemWidth;

        const sequence = utils.getSequence(dialog.portfolio);

        this.groupList = [];
        if (sequence) {
            sequence.forEach((groupName) => {
                const groupFiltered = node.filter(f => f.name === groupName);

                if (groupFiltered.length > 0) this.groupList.push(groupFiltered[0]);
            })
        } else {
            node.forEach((d) => {
                this.groupList.push(d);
            });
        }

        if (appModus === "Admin") {
            this.groupList.push({ name: '_NEW', path: null });
        }

        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================

        const renderGroupReorder = () => {

            if (file?.type === 'FILE_UPLOAD_PROGRESS') return null;

            // Allgemeine AG-Grid Konfiguration
            const defaultColDef = {
                sortable: false,
                editable: false,
                filter: false,
                resizable: false,
                enableValue: false,
                enableRowGroup: false,
                enablePivot: false
            }

            // Spalten konfigurieren    
            const columnsDefsRight = [
                {
                    headerName: "",
                    field: "name",
                    width: itemWidth * .5,
                    rowDrag: true,
                    cellRenderer: "itemRenderer",
                },
            ];

            // Inizalisierung
            const onGridRightReady = (params) => {
                this.agGridRightApi = params.api;
                this.agGridRightColumnApi = params.columnApi;
                params.api.sizeColumnsToFit();
            }

            // callbacks
            const onChange = (d) => {
                console.log('onChange()', d);
            }

            const onRowDragEnd = () => {
                console.log('onRowDragEnd()');
                let reorderList = [];
                this.agGridRightApi.forEachNode((d) => {
                    if (d.data.name !== '_NEW') {
                        reorderList.push(d.data.name);
                    }
                });

                this.props.uploadJSON(path, 'sequence.json', reorderList, () => {
                    this.props.scanPortfolio(dialog.portfolio, null, null, dialog.portfolio);
                }, (error) => {
                    console.log('uploadJSON(error)', error);
                });
            }

            const onCellClicked = (event) => {
            }

            const renderItem = (d, i) => {

                const renderIconFree = (d) => {
                    const firstFree = utils.getGroupImage(d);

                    let imageURL = null;
                    if (firstFree) {
                        imageURL = utils.getURL('product', currentPortfolio.name + '/' + firstFree.groupName + '/' + firstFree.productName, firstFree.fileName);
                    }

                    const style = utils.getStyleBackgroundURL(imageURL, '75%', '60%');

                    const productsInGroup = utils.getProductsInGroup(d);

                    const onEdit = () => {
                        this.props.setPath(currentPortfolio.name + '/' + d.name);
                        this.props.setCurrentGroup(d); // portfolioActions.js

                        this.props.setModalDialog('GroupModal', 'update');
                    }

                    const onDelete = () => {
                        this.props.setPath(currentPortfolio.name + '/' + d.name);
                        this.props.setCurrentGroup(d); // portfolioActions.js

                        this.props.setModalDialog('GroupModal', 'delete');
                    }

                    return (
                        <div className="flex flex-col justify-center w-full text-center text-gray-900" style={style}>
                            <div className="w-full h-full">
                                {IconEdit(unitHeight, onEdit)}
                                {!productsInGroup && IconDelete(unitHeight, onDelete)}
                            </div>
                        </div>

                    )
                }

                const renderTitle = (d) => {
                    const style = { height: '25%' }

                    return (
                        <div className="flex flex-col justify-center w-full whitespace-no-wrap overflow-x-auto text-start text-black font-semibold" style={style}>
                            <div className="flex w-full" style={utils.getStyleHeight(fontFactor, 1, .7, .7)}>
                                {d.name}
                            </div>
                        </div>
                    )
                }

                const style = { width: itemWidth, height: itemWidth, minHeight: itemWidth };

                const onClick = () => {
                    this.props.setPath(currentPortfolio.name + '/' + d.data.name);
                    this.props.setCurrentGroup(d.data);
                }

                if (d.data.name === '_NEW') {
                    const onClick = () => {
                        this.props.setPath(currentPortfolio.name);
                        this.props.setModalDialog('GroupModal', 'create');
                    }

                    return (
                        <div className="flex flex-col text-center justify-center text-gray-400 text-8xl" onClick={onClick} style={{ ...style }}>
                            <div>＋</div>
                        </div>
                    )
                } else {
                    return (
                        <div key={i} className="w-full" style={style} onClick={onClick}>
                            {renderIconFree(d.data)}
                            {renderTitle(d.data)}
                        </div>
                    )
                }

            }

            // ###############################################################
            // renderDetailList()
            // ###############################################################

            const style = {
                width: (orientation === 'landscape') ? '20%' : '25%',
                height: (inputHeight * 0.98) + 'px',
                minHeight: (inputHeight * 0.98) + 'px',
                overflow: 'hidden'
            };

            this.timestamp = new Date().getTime();

            return (
                <div key={'group' + this.timestamp} className="w-1/4 ag-theme-material mt-2 pl-2 overflow-hidden" style={style}>
                    <AgGridReact
                        id="adminGroups"
                        onGridReady={onGridRightReady}

                        // General definitions
                        sideBar={false}

                        // Column
                        columnDefs={columnsDefsRight}
                        defaultColDef={defaultColDef}

                        // Row
                        rowData={this.groupList}
                        rowHeight={this.agGridRowHeight}
                        rowSelection={"single"}
                        rowMultiSelectWithClick={false}
                        onRowDragEnd={onRowDragEnd}
                        onCellValueChanged={onChange}
                        rowDragManaged={true}
                        onCellClicked={onCellClicked}

                        // Header
                        headerHeight={this.agGridHeaderHeight}

                        // Pagination
                        pagination={false}
                        paginationAutoPageSize={false}
                        suppressScrollOnNewData={false}

                        // Editing
                        singleClickEdit={false}

                        // cell renderer
                        frameworkComponents={{
                            itemRenderer: renderItem
                        }}
                    />
                </div>
            )
        }



        // ###############################################################
        // GroupList / Produktgruppen anzeigen
        // ---------------------------------------------------------------
        // Auf der linken Seite werden die Produktgruppen als vertikale Liste 
        // angezeigt.
        // ###############################################################
        const renderGroupsList = () => {

            const renderItem = (d, i) => {

                const renderIconFree = () => {
                    const id = 'gnav' + d.name;

                    if (d.name === '_NEW') {
                        return (
                            <div className="flex flex-col items-center justify-center w-full text-center text-gray-400 ">
                                <div className="flex justify-center w-full px-2" style={utils.getStyleHeight(fontFactor, 8, 8, 8)}>＋</div>
                            </div>
                        )
                    }

                    const firstFree = utils.getGroupImage(d);

                    if (appModus === 'Admin') {

                        const onEdit = () => {
                            this.props.setPath(currentPortfolio.name + '/' + d.name);
                            this.props.setCurrentGroup(d); // portfolioActions.js

                            this.props.setModalDialog('GroupModal', 'update');
                        }

                        const onDelete = () => {
                            this.props.setPath(currentPortfolio.name + '/' + d.name);
                            this.props.setCurrentGroup(d); // portfolioActions.js

                            this.props.setModalDialog('GroupModal', 'delete');
                        }

                        let imageURL = null;
                        if (firstFree) {
                            imageURL = utils.getURL('product', currentPortfolio.name + '/' + firstFree.groupName + '/' + firstFree.productName, firstFree.fileName);
                        }

                        const style = utils.getStyleBackgroundURL(imageURL, '75%', '80%');

                        const productsInGroup = utils.getProductsInGroup(d);

                        return (
                            <div id={id} className="flex flex-col justify-center w-full text-center text-gray-900 " style={style}>
                                <div className="relative w-full h-full">
                                    {IconEdit(unitHeight, onEdit)}
                                    {productsInGroup === 0 && IconDelete(unitHeight, onDelete)}
                                </div>
                            </div>
                        )

                    } else {
                        if (!firstFree) return null;

                        return (<ImageLoader path={firstFree.node.path} name={firstFree.node.name} height={'75%'} cover={'80%'} />)
                    }
                }

                const renderTitle = () => {
                    const style = {
                        height: '25%'
                    }

                    return (
                        <div className="flex flex-col justify-center w-full whitespace-no-wrap overflow-x-auto text-center text-black font-semibold px-2" style={style}>
                            <div className="flex justify-center w-full px-2" style={utils.getStyleHeight(fontFactor, 1, .7, .7)}>
                                {d.name}
                            </div>
                        </div>
                    )
                }

                // ###############################################################
                // renderItem
                // ###############################################################
                const styleStandard = { backgroundColor: 'white' };
                const styleSelected = { backgroundColor: 'rgb(217, 216, 218)' };

                const getStyle = (group) => {
                    return (group === dialog.groups) ? styleSelected : styleStandard;
                };

                const style = Object.assign({ width: itemWidth + 'px', height: itemWidth + 'px', minHeight: itemWidth + 'px' }, getStyle(d.name));

                if (d.name === '_NEW') {
                    const onClick = () => {
                        this.props.setPath(currentPortfolio.name);
                        this.props.setModalDialog('GroupModal', 'create');
                    }

                    return (
                        <div key={i} className="w-full h-full rounded m-1 shadow-md" style={style} onClick={onClick}>
                            <div className="flex h-full w-full items-center">
                                <div className="flex justify-center w-full h-full px-2 text-gray-400" style={utils.getStyleHeight(fontFactor, 8, 8, 8)}>＋</div>
                            </div>
                        </div>
                    )
                }
                else {
                    const onClick = () => {
                        const pos = document.getElementById('groupNavi').scrollTop;
                        this.props.setGroupPos(pos);

                        this.props.setPath(currentPortfolio.name + '/' + d.name);
                        this.props.setCurrentGroup(d);
                    }

                    return (
                        <div key={i} className="w-full rounded m-1 shadow-md" style={style} onClick={onClick}>
                            {renderIconFree()}
                            {renderTitle()}
                        </div>
                    )
                }
            }

            // ==========================================================================
            // renderGroupsList
            // ==========================================================================

            const style = {
                width: (orientation === 'landscape') ? '20%' : '25%',
                height: inputHeight + 'px',
                minHeight: inputHeight + 'px'
            };

            setTimeout(() => {
                const element = document.getElementById('groupNavi')
                if (element !== null && groupPos !== null) {
                    element.scrollTop = groupPos
                }
            }, 1)

            return (
                <div className="flex flex-col items-center py-2" style={style}>
                    <div id='groupNavi' className="flex flex-col items-center overflow-y-auto" >
                        {this.groupList.map((d, i) => renderItem(d, i))}
                    </div>
                </div>
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================

        const style = {
            top: headerHeight + 'px',
            width: windowWidth + 'px',
            height: inputHeight + 'px'
        };

        if (dialog.dialogType !== 'groups') return null;

        if (['search', 'filter', 'favored'].includes(toolbarType)) return null;

        const key = new Date().toLocaleString()

        return (
            <div key={key} className="w-full flex flex-col z-10 bg-forsales-gray" style={style}>
                <div className="w-full flex" >
                    {appModus === 'Admin' ? renderGroupReorder() : renderGroupsList()}
                </div>
                {orientation === 'portrait' ? <GroupPortrait /> : <GroupLandscape />}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        user: state.user,
        file: state.file,
        portfolio: state.portfolio,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, fileActions, portfolioActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupController);
